import React from 'react'
import {Link} from 'react-router-dom'

export default function Breadcumb(props) {
  return (
    <>
    <section className="position-relative bg-[#FBF8F1] md:pt-28 pt-10 pb-10">
      <div className="pagebannertext text-center">
          <h2 className='text-4xl font-bold mb-5 headningfont '>{props.pagetitle}</h2>
          <div className='flex gap-4 justify-center tracking-wider'>
            <Link to="/" className="text-[#a27800]">Home</Link>
            <span>/</span>
            <span>{props.pagetitle}</span>
          </div>
      </div>
    </section>
    </>
  )
}
